import config from "../../config/config.json";
import { headers } from "../../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody,
  cancelPreviousRequest,
  decryptResponse
} from "../../APIHelpers/Responses";

export const contactServices = {
  addNewContact,
  updatedContact,
  deleteContact,
  getContactList,
  getSingleContact,
};

// Add New Contact
async function addNewContact(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewContact`,
    headersWithAuth("POST", userData, headers)
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data)
  return data;
}

// Update Contact
async function updatedContact(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updatedContact`,
    headersWithAuth("PUT", userData, headers)
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data)
  return data;
}

// Delete Contact
async function deleteContact(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}deleteContact`,
    headersWithAuth("DELETE", userData, headers)
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data)
  return data;
}

// Get All Contact
async function getContactList(status, search, page, length) {
  try {
    const signal = cancelPreviousRequest(`getContactList`);
    let apiURL;
    if (page && length) {
      apiURL = `${config.API_URL_USER_ONBOARDING}getContactList/${status}?search=${search || ""}&page=${page}&length=${length}`;
    } else {
      apiURL = `${config.API_URL_USER_ONBOARDING}getContactList/${status}?search=${search || ""}`;
    }
    const response = await fetch(apiURL, {
      ...headersWithAuthWithoutBody("GET", headers),
      signal
    });
    const result = await response.json();
    const data = decryptResponse(result);
    if (data?.statusCode === 401) {
      handleResponse(data)
    }
    return data;
  } catch (err) {
    if (err.name === "AbortError") {
      return "AbortError";
    }
    throw err;
  }
}

// Get Single Contact
async function getSingleContact(contactId) {
  try {
    const signal = cancelPreviousRequest(`getSingleContact`);
    let apiURL = `${config.API_URL_USER_ONBOARDING}getSingleContact/${contactId}`
    const response = await fetch(apiURL, {
      ...headersWithAuthWithoutBody("GET", headers),
      signal
    });
    const result = await response.json();
    const data = decryptResponse(result);
    if (data?.statusCode === 401) {
      handleResponse(data)
    }
    return data;
  } catch (err) {
    if (err.name === "AbortError") {
      return "AbortError";
    }
    throw err;
  }
}